import React from 'react';
import Icon from '@/components/ui/Icon';
import { IExerciseProgress } from './utils/ReadingAssignmentsTable.types';

interface IReadingStatusIndicatorProps {
  progress: IExerciseProgress;
}

export function ReadingStatusIndicator({ progress }: IReadingStatusIndicatorProps) {
  if (!progress) return <>-</>;

  return (
    <Icon
      fill={progress.status === 'completed' ? '#78962d' : '#ffca17'}
      icon="Circle"
      size={12}
    />
  );
}
